import React from "react";
import { useContext } from "react";
import { Controller } from "react-hook-form"
import Select from 'react-select'

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';


const TYPES = {
  "CONTRACT": "шаблон договора",
  "ORDER_FORM": "шаблон бланка заказа",
  "INVOICE": "шаблон счета",
}

export function GetTemplateType (type) {
  return TYPES[type]
}


export function TemplateForm ({groups, control, register, handleSubmit, onSubmit, templateFile, signFile, nameFieldDisabled}) {
  const media_url = useContext(MEDIA_URL);


  let groupOptions = [];
  for (let i in groups) {
    groupOptions.push(
      { value: groups[i].id, label: groups[i].name }
    );
  }

  //console.log(groupOptions)

  let typeOptions = []
  for (let i in Object.keys(TYPES)){
    typeOptions.push(
      { value: Object.keys(TYPES)[i], label: Object.values(TYPES)[i] }
    )
  }

  //console.log (typeOptions)

  return (
    <div className="row">
      <div className="col-5">
        <div className="ms-3 mt-4 lk-form">
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">

            <div className="input-group my-4">
              <label className="">
                <p>Название шаблона</p>
                <div >
                <input className="form-control" style={{width: '400px'}} disabled={nameFieldDisabled} {...register("name")} />
                </div>
              </label>
            </div>
            {/**
            <div className="input-group my-4">
              <label className="">
                <p>Тип шаблона</p>
                <div style={{width: '400px'}}>
                <Controller
                  name="type"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={typeOptions}
                      placeholder="выберите тип"
                      isDisabled={true}
                    />
                  )}
                />
                </div>
              </label>
            </div>
            */}
            <div className="input-group my-4">
              <label className="">
                <p>файл шаблона</p>
                {templateFile ? 
                  <>
                    <a className="m-1" href={media_url + templateFile} target="_blank" rel="noopener noreferrer">текущий файл шаблона</a>
                    <input type="file" className="" style={{width: '400px'}} {...register("template_file")} />
                  </>
                  :
                  <input type="file" className="form-control" style={{width: '400px'}} {...register("template_file")} />
                }
                
              </label>
            </div>
            <div className="input-group my-4">
              <label className="">
                <p>файл подписи</p>
                {signFile ? 
                  <>
                    <a className="m-1" href={media_url + signFile} target="_blank" rel="noopener noreferrer">текущий файл подписи</a>
                    <input type="file"  className="" style={{width: '400px'}} {...register("signature_file")} />
                  </>
                  :
                  <input type="file"  className="form-control" style={{width: '400px'}} {...register("signature_file")} />
                }

              </label>
            </div>    
            <div className="input-group my-4">
              <label className="">
                <p>группы, которым доступен шаблон</p>
                  <div style={{width: '600px'}}>
                  <Controller
                    name="group"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={groupOptions}
                        placeholder="добавьте группы"
                        isMulti
                      />
                    )}
                  />
                  </div>
              </label>
            </div>    
            <div className="mt-5">
              <button className="lk-button" type="submit">Сохранить</button>
            </div>
          </form>
        </div>
      </div>
    </div>    
  )
}